import React, { useState } from 'react'
import { getLoginInfo } from './getLoginInfo';


export const authContext = React.createContext();

const Auth = (props) => {
    const [isLogin, setIsLogin] = useState(getLoginInfo() ? true : false);
    return (
        <authContext.Provider value={[isLogin, setIsLogin]}>
            {props.children}
        </authContext.Provider>
    );
}

export default Auth;